import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./RootReducer";

const store = configureStore({ reducer: rootReducer });

export type AppState = ReturnType<typeof rootReducer>;
export default store;

(window as any)["getReducerStore"] = store;
